import * as React from "react";
import {
  Button,
  ButtonGroup
} from "@blueprintjs/core";
import i18next from "i18next";

import { getSetting } from "../Settings/InstallationSettings";

function LanguageSelector(props) {
  if (i18next.language === undefined) {
    var browseerlg = navigator.language || navigator.userLanguage;
    if (browseerlg !== undefined) {
      i18next.changeLanguage(browseerlg.split("-")[0].toLowerCase());
    } else {
      i18next.changeLanguage('en'); //default language
    }
  }

  return (
    <ButtonGroup>
      {getSetting("🇫🇷 display french language button", true) &&
        <Button
          intent={i18next.language.split("-")[0].toLowerCase() === "fr" ? "primary" : "none"}
          onClick={() => {
            i18next.changeLanguage('fr');
          }}>
          <img
            alt="fr"
            className="flag"
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABmJLR0QA/wD/AP+gvaeTAAAAl0lEQVQ4jWNgGGjAGNd97J6gAD8zTODXz5/cTjpcDMoyAl+RFX6/cZ1bdNNyBg52drj4x1ev/rIICvAzy8hIy8EEv3z+wiAtxsKgIicujGzAm/cvGQQkJRk4BQSQxR8xUeqFUQNGDWBgYGBgef/h418GBoZHMIFfP39yP33FxcDBxoCalF++4/7z/DkDx7t3KEmZUgdQDgDIpy9/kSmh+AAAAABJRU5ErkJggg=="
          />
        </Button>}

      {getSetting("🇬🇧 display english language button", true) &&
        <Button
          intent={i18next.language.split("-")[0].toLowerCase() === "en" ? "primary" : "none"}
          onClick={() => {
            i18next.changeLanguage('en-US');
          }}>
          <img
            alt="en"
            className="flag"
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABmJLR0QA/wD/AP+gvaeTAAACOklEQVQ4jcWS20vTcRjGP/vu547yMyeeljpvIsupCWlqEwWLNDJDpIIoqMuwoCT6J/Kiruqi6KISQaILLQ9YRGomEc6WNkImZb90zjWn7uQO3aggrIvwouf2eQ/P87wv/G+o+kdnloXGEBic9I2vBMLhLULWCWPT/LAN4FVew4g/FF/f4oQKmsr2lKdNDFmkrKEe075zbaaaiyVtg1+CzLo3AMiW1RxYeQ2AYt1/ZtEfAyBNL2hIc5MY6CFiO4YYr7jg9nydxfPoPi3FapoPGdCnqJLKLc9P4aR3GI19BMuNDlzavX7JqQRDEUst1aWLbHR2Ym5u5nKtlQnXthuMOkFruo9EbxdyYyOhwoM8+xjk07TXJ2XKksZkFDjJJevUdcTnPtK8Xurr6lA2BzRo51gZHcPcfg2nVzDpCKICMmVJo5q8eTuWmZMhkklWb2Ya02qTWlpaWI4nbfwXSL1HrrgL8sw5agFl+RqKTHF+Pn2CXF1D4GUfALqrHaTrQenuJpKey1R2Jf5gnO/zilss+aMRIeCE1YDFP8vcvbtEKo8zHCrc3tJnDzA0Eybr7HlkvYriNw+wGEJ4VmMR6fThDFO9Vc/ii+esBUJ8a2rHoUTJluM7pE79iDDvjdJYZiO/qAjV44dcKqkyC3P4V6qr8w5rhSX0F7TgUKJ/9etdj9P1YY23HpmCjltIypwkLbwbW/9d1eoaeO+zxxP+7eIFnTCaVxM2ALvDueOVnU6Ymk41FZcerdjtEXaPP1Rp2nfCxOslAAAAAElFTkSuQmCC"
          />
        </Button>
      }

      {getSetting("🇮🇹 display italian language button", false) &&
        <Button
          intent={i18next.language === "it" ? "primary" : "none"}
          onClick={() => {
            i18next.changeLanguage('it');
          }}>
          <img
            alt="it"
            className="flag"
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABmJLR0QA/wD/AP+gvaeTAAAAhUlEQVQ4jWNgGGjAmLuy8Z4QNxczQoiJjYtJWMBVzeMVssL/i+eICb9//YHp/79fMLGPr179ZRHi5mKWEhWWQ1bM9IuXQUVOHEXslbAgg7gAtwSaAx4xUeqFUQNGDWBgYGBgeff1218GBoZHSGaycTExCdx59BI1Kb99L8aCJSlT6gDKAQBGOimokIitwwAAAABJRU5ErkJggg=="
          />
        </Button>
      }

      {getSetting("🇩🇪 display german language button", false) &&
        <Button
          intent={i18next.language === "de" ? "primary" : "none"}
          onClick={() => {
            i18next.changeLanguage('de');
          }}>
          <img
            alt="de"
            className="flag"
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABmJLR0QA/wD/AP+gvaeTAAAAhklEQVQ4jWNgGGjAaOMVcY+Ni5eZHM2/vn3+y8LGxcvMKSAkR6YDHjGRqREOWLi+fxZjYWT4SY5mxu+fxVimKYm+ElVSIssLr+/do9wLlIfBl09veRmeMH4iR/OXT295GX/d7n/IKixCVhj8fvtmMITBv8+f//5mYHhEjuZ/nz//pdQBlAMACvkqYyvGRTsAAAAASUVORK5CYII="
          />
        </Button>
      }
    </ButtonGroup>
  );
}

export default LanguageSelector
